import { SoccerEventStatusId } from '@collector/sportsapi-client-legacy'

export const SoccerManualAddStatusIds: SoccerEventStatusId[] = [
  SoccerEventStatusId.FirstHalf,
  SoccerEventStatusId.SecondHalf,
  SoccerEventStatusId.ExtratimeFirstHalf,
  SoccerEventStatusId.ExtratimeSecondHalf,
]
